// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__1Yv2x","search":"Settings_search__7g0KH","filter":"Settings_filter__xyYXs"};